<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
          <h3 class="card-title mb-0">Account Payable</h3>
          <div class="ml-auto">
            <vs-button @click="inputTrans" color="success" type="filled" class="mt-4 mt-md-0">
              <i class="mdi mdi-plus-circle mr-1"></i> Input AP
            </vs-button>
          </div>
        </div>
        <hr class="custom-hr" />

        <!-- Filter Row -->
        <vs-row class="mb-3">
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
              <label class="vs-input--label">Tanggal Dari</label>
              <div class="vs-con-input">
                <date-picker
                  v-model="filter.tanggal_from"
                  format="DD-MM-YYYY"
                  value-type="format"
                  placeholder="Dari Tanggal"
                  input-class="vs-input--input"
                />
              </div>
            </div>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
              <label class="vs-input--label">Tanggal Sampai</label>
              <div class="vs-con-input">
                <date-picker
                  v-model="filter.tanggal_to"
                  format="DD-MM-YYYY"
                  value-type="format"
                  placeholder="Sampai Tanggal"
                  input-class="vs-input--input"
                />
              </div>
            </div>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="3">
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
              <label class="vs-input--label">Jenis Hutang</label>
              <select class="vs-input--input w-100" v-model="filter.jenis_hutang" style="height:38px;border:1px solid #d9d9d9;border-radius:5px;padding:0 8px;">
                <option value="">Semua</option>
                <option value="lokal">Lokal</option>
                <option value="impor">Impor</option>
              </select>
            </div>
          </vs-col>
          <vs-col vs-lg="1" vs-xs="12" vs-sm="2">
            <div class="mt-4" style="padding-top:22px;">
              <vs-button @click="loadData" color="primary" type="filled">
                <i class="mdi mdi-magnify mr-1"></i> Cari
              </vs-button>
            </div>
          </vs-col>
        </vs-row>

        <!-- Main Grid -->
        <JqxGrid
          ref="myGrid"
          :autorowheight="true"
          :autoheight="true"
          :width="width"
          :theme="'material-green'"
          :selectionmode="'singlerow'"
          :pageable="true"
          :sortable="true"
          :filterable="true"
          :showfilterrow="true"
          :columnsresize="true"
          :source="dataAdapter"
          :columns="columns"
          @rowclick="myGridOnRowClick($event)"
          @contextmenu="myGridOnContextMenu()"
          @rowselect="onRowSelect($event)"
        />

        <!-- Context Menu -->
        <JqxMenu
          ref="myMenu"
          @itemclick="myMenuOnItemClick($event)"
          :width="200"
          :height="60"
          :mode="'popup'"
          :autoOpenPopup="false"
        >
          <ul>
            <li>Edit</li>
            <li>Hapus</li>
          </ul>
        </JqxMenu>

        <br />

        <!-- Tab: Detail / Jurnal -->
        <div class="tab-header mb-2">
          <vs-button
            :color="activeTab === 'detail' ? 'primary' : 'dark'"
            :type="activeTab === 'detail' ? 'filled' : 'flat'"
            size="small"
            @click="activeTab = 'detail'"
          >Detail AP</vs-button>
          <vs-button
            :color="activeTab === 'jurnal' ? 'warning' : 'dark'"
            :type="activeTab === 'jurnal' ? 'filled' : 'flat'"
            size="small"
            class="ml-1"
            @click="activeTab = 'jurnal'"
          ><i class="mdi mdi-book-open-page-variant mr-1"></i>Jurnal Akuntansi</vs-button>
        </div>

        <!-- Detail AP Grid -->
        <div v-show="activeTab === 'detail'">
          <h5 class="mb-1">Rincian Account Payable</h5>
          <JqxGrid
            ref="detailGrid"
            :width="width"
            :height="220"
            :keyboardnavigation="false"
            :columns="detailColumns"
            :showstatusbar="true"
            :showaggregates="true"
            :columnsresize="true"
          />
        </div>

        <!-- Jurnal Akuntansi Grid -->
        <div v-show="activeTab === 'jurnal'">
          <h5 class="mb-1">
            Jurnal Akuntansi
            <span class="text-muted" style="font-size:0.8em;font-weight:normal;">
              — Debit: Akun Biaya/Beban | Kredit: Hutang Usaha
            </span>
          </h5>
          <JqxGrid
            ref="jurnalGrid"
            :width="width"
            :height="220"
            :keyboardnavigation="false"
            :columns="jurnalColumns"
            :showstatusbar="true"
            :showaggregates="true"
            :columnsresize="true"
          />
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import JqxGrid from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue';
import JqxMenu  from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxmenu.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: { JqxGrid, JqxMenu, DatePicker },
  data() {
    return {
      width: '100%',
      activeTab: 'detail',
      filter: {
        tanggal_from: '',
        tanggal_to: '',
        jenis_hutang: '',
      },
      // eslint-disable-next-line
      dataAdapter: new jqx.dataAdapter(
        {
          datafields: [
            { name: 'id',            type: 'number' },
            { name: 'no_ap',         type: 'string' },
            { name: 'tanggal',       type: 'date' },
            { name: 'jatuh_tempo',   type: 'date' },
            { name: 'nama_supplier', type: 'string' },
            { name: 'no_referensi',  type: 'string' },
            { name: 'nomor_fp',      type: 'string' },
            { name: 'keterangan',    type: 'string' },
            { name: 'total_nilai',   type: 'number' },
            { name: 'total_bayar',   type: 'number' },
            { name: 'sisa_hutang',   type: 'number' },
            { name: 'jenis_hutang',  type: 'string' },
          ],
          datatype: 'json',
          id: 'id',
          url: this.$urlbackend + '/api/accountpayable',
          type: 'get',
        },
        {
          formatData: (data) => JSON.stringify(data),
          beforeSend: (jqxhr, settings) => {
            settings.xhrFields = { withCredentials: true };
            jqxhr.setRequestHeader('X-XSRF-TOKEN', window.$cookies.get('XSRF-TOKEN'));
          },
        }
      ),
      columns: [
        { text: 'No AP',        datafield: 'no_ap',         width: '13%' },
        { text: 'Tanggal',      datafield: 'tanggal',       width: '9%', cellsformat: 'dd-MM-yyyy' },
        { text: 'Jatuh Tempo',  datafield: 'jatuh_tempo',   width: '9%', cellsformat: 'dd-MM-yyyy' },
        {
          text: 'Jenis', datafield: 'jenis_hutang', width: '8%',
          cellsrenderer: (index, datafield, value) => {
            if (value === 'impor') {
              return '<div style="margin:6px;"><span style="background:#fff3e0;color:#e65100;border:1px solid #ffcc80;border-radius:10px;padding:2px 8px;font-size:0.82em;font-weight:bold;">IMPOR</span></div>';
            }
            return '<div style="margin:6px;"><span style="background:#e3f2fd;color:#1565c0;border:1px solid #90caf9;border-radius:10px;padding:2px 8px;font-size:0.82em;font-weight:bold;">LOKAL</span></div>';
          },
        },
        { text: 'Supplier',     datafield: 'nama_supplier', width: '22%' },
        { text: 'No Referensi', datafield: 'no_referensi',  width: '10%' },
        { text: 'Nomor FP',     datafield: 'nomor_fp',      width: '10%' },
        { text: 'Total Nilai',  datafield: 'total_nilai',   width: '11%', cellsformat: 'D', cellsalign: 'right' },
        { text: 'Sisa Hutang',  datafield: 'sisa_hutang',   width: '11%', cellsformat: 'D', cellsalign: 'right' },
      ],
      detailColumns: [
        { text: 'Kode Perk',  datafield: 'kode_perk',  width: '15%' },
        { text: 'Nama Perk',  datafield: 'nama_perk',  width: '30%' },
        { text: 'Keterangan', datafield: 'keterangan', width: '35%' },
        { text: 'Nilai',      datafield: 'nilai',      width: '20%', cellsformat: 'D', cellsalign: 'right' },
      ],
      jurnalColumns: [
        { text: 'Referensi',  datafield: 'referensi', width: '16%' },
        { text: 'Tanggal',    datafield: 'tanggal',   width: '12%', cellsformat: 'dd-MM-yyyy' },
        { text: 'Kode',       datafield: 'kode',      width: '10%' },
        { text: 'Uraian',     datafield: 'uraian',    width: '30%' },
        {
          text: 'Debet', datafield: 'debet', width: '16%', cellsformat: 'D', cellsalign: 'right',
          cellsrenderer: (index, datafield, value) => {
            const v = parseFloat(value);
            const color = v > 0 ? '#d32f2f' : '#888';
            return `<div style="margin:8px;text-align:right;color:${color}">${v > 0 ? v.toLocaleString('id-ID', {minimumFractionDigits:2}) : '-'}</div>`;
          },
        },
        {
          text: 'Kredit', datafield: 'kredit', width: '16%', cellsformat: 'D', cellsalign: 'right',
          cellsrenderer: (index, datafield, value) => {
            const v = parseFloat(value);
            const color = v > 0 ? '#1565c0' : '#888';
            return `<div style="margin:8px;text-align:right;color:${color}">${v > 0 ? v.toLocaleString('id-ID', {minimumFractionDigits:2}) : '-'}</div>`;
          },
        },
      ],
    };
  },
  methods: {
    inputTrans() {
      this.$router.push({ name: 'apinput' });
    },
    loadData() {
      const filterPayload = {};
      if (this.filter.tanggal_from) filterPayload.tanggal_from = this.convertDate(this.filter.tanggal_from);
      if (this.filter.tanggal_to)   filterPayload.tanggal_to   = this.convertDate(this.filter.tanggal_to);
      if (this.filter.jenis_hutang !== '') filterPayload.jenis_hutang = this.filter.jenis_hutang;

      const source = {
        datafields: [
          { name: 'id',            type: 'number' },
          { name: 'no_ap',         type: 'string' },
          { name: 'tanggal',       type: 'date' },
          { name: 'jatuh_tempo',   type: 'date' },
          { name: 'nama_supplier', type: 'string' },
          { name: 'no_referensi',  type: 'string' },
          { name: 'nomor_fp',      type: 'string' },
          { name: 'keterangan',    type: 'string' },
          { name: 'total_nilai',   type: 'number' },
          { name: 'total_bayar',   type: 'number' },
          { name: 'sisa_hutang',   type: 'number' },
          { name: 'jenis_hutang',  type: 'string' },
        ],
        datatype: 'json',
        id: 'id',
        url: this.$urlbackend + '/api/aplist',
        type: 'post',
        data: filterPayload,
      };
      // eslint-disable-next-line
      const adapter = new jqx.dataAdapter(source, {
        formatData: (data) => JSON.stringify({ ...data, ...filterPayload }),
        beforeSend: (jqxhr, settings) => {
          settings.xhrFields = { withCredentials: true };
          jqxhr.setRequestHeader('X-XSRF-TOKEN', window.$cookies.get('XSRF-TOKEN'));
        },
      });
      this.$refs.myGrid.source = adapter;
    },
    convertDate(ddmmyyyy) {
      if (!ddmmyyyy) return null;
      const parts = ddmmyyyy.split('-');
      if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
      return ddmmyyyy;
    },
    onRowSelect(event) {
      const rowData = event.args.row;
      if (!rowData || !rowData.id) return;

      // Load detail AP
      this.$http.get('/api/accountpayable/' + rowData.id).then(resp => {
        const data    = resp.data || {};
        const details = data.details || [];

        // Detail grid
        const detailSource = {
          datafields: [
            { name: 'kode_perk',  type: 'string' },
            { name: 'nama_perk',  type: 'string' },
            { name: 'keterangan', type: 'string' },
            { name: 'nilai',      type: 'number' },
          ],
          datatype: 'array',
          localdata: details,
          id: 'id',
        };
        // eslint-disable-next-line
        this.$refs.detailGrid.source = new jqx.dataAdapter(detailSource);

        // Jurnal grid
        const jurnals = data.jurnals || [];
        const jurnalSource = {
          datafields: [
            { name: 'referensi', type: 'string' },
            { name: 'tanggal',   type: 'date' },
            { name: 'kode',      type: 'string' },
            { name: 'uraian',    type: 'string' },
            { name: 'debet',     type: 'number' },
            { name: 'kredit',    type: 'number' },
          ],
          datatype: 'array',
          localdata: jurnals,
          id: 'id',
        };
        // eslint-disable-next-line
        this.$refs.jurnalGrid.source = new jqx.dataAdapter(jurnalSource);
      }).catch(() => {});
    },
    myGridOnContextMenu() {
      return false;
    },
    myGridOnRowClick(event) {
      if (event.args.rightclick) {
        this.$refs.myGrid.selectrow(event.args.rowindex);
        const scrollTop  = window.scrollY;
        const scrollLeft = window.scrollX;
        this.$refs.myMenu.open(
          parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft,
          parseInt(event.args.originalEvent.clientY) + 5 + scrollTop
        );
        return false;
      }
    },
    myMenuOnItemClick(event) {
      const label    = event.args.innerHTML;
      const rowindex = this.$refs.myGrid.getselectedrowindex();
      const rowid    = this.$refs.myGrid.getrowid(rowindex);
      const data     = this.$refs.myGrid.getrowdatabyid(rowid);

      if (label === 'Edit') {
        if (!data) return;
        if (parseFloat(data.total_bayar) > 0) {
          this.$vs.notify({ title: 'Tidak Bisa', text: 'Hanya AP yang belum ada pembayaran yang bisa diedit', color: 'warning' });
          return;
        }
        this.$router.push({ name: 'apedit', params: { ref: data.id } });
      }

      if (label === 'Hapus') {
        if (!data) return;
        if (parseFloat(data.total_bayar) > 0) {
          this.$vs.notify({ title: 'Tidak Bisa', text: 'Hanya AP yang belum ada pembayaran yang bisa dihapus', color: 'warning' });
          return;
        }
        if (confirm('Hapus AP ' + data.no_ap + '? Jurnal terkait juga akan dihapus.')) {
          this.$http.delete('/api/accountpayable/' + data.id).then(() => {
            this.$refs.myGrid.deleterow(rowid);
            this.$vs.notify({ title: 'Berhasil', text: 'Data dan jurnal berhasil dihapus', color: 'success' });
          }).catch(err => {
            const msg = err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : 'Gagal menghapus data';
            this.$vs.notify({ title: 'Gagal', text: msg, color: 'danger' });
          });
        }
      }
    },
  },
  mounted() {
    document.addEventListener('contextmenu', event => event.preventDefault());
  },
};
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
<style lang="stylus">
.tab-header
  border-bottom 1px solid #e0e0e0
  padding-bottom 8px
</style>
